export const abTests = {
	IXO_IN_PRODUCT_EXPERIENCE: {
		testName: '2022-01-27_ixo_in_product_experience',
		inGroup: 'SHOW_IXO',
		controlGroup: 'CONTROL-NO_IXO'
	},
	GROWTH_GOALS_MONTHLY_SUGGESTION: {
		testName: '2022-01-25_growth_goals_monthly_suggestion',
		inGroup: 'SHOW_MONTHLY_SUGGESTIONS',
		controlGroup: 'CONTROL-EXISTING_GOAL_AMOUNT'
	}
};
